import CantSeePastFirstPost from './CantSeePastFirstPost';

export const components = {
    CantSeePastFirstPost,
};
